import {Component} from "react";
import * as React from "react";

import {XdSentry} from "@Common/libs/sentry/xd-sentry";

XdSentry.init({
    dsn: "https://4516ec3fec66442cbdbb5205f29e876c@sentry.io/1434855",

    environment: (
        window.location.hostname == "www.xpressdocs.com" ? (
            "production"
        ) : window.location.hostname.includes("stage") ? (
            "stage"
        ) : (
            "dev"
        )
    ),
});

interface P {
    next;
}
interface S {
    error;
    eventId;
}

export class ErrorBoundary extends Component<P,S> {
    constructor(props) {
        super(props);
        this.state = { error: null, eventId: null };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error });
        XdSentry.withScope(scope => {
            scope.setExtras(errorInfo);
            const eventId = XdSentry.captureException(error);
            this.setState({eventId})
        });
    }

    render() {
        const {next} = this.props;
        if (this.state.error) {
            //render fallback UI
            return (
                <a onClick={() => XdSentry.showReportDialog({ eventId: this.state.eventId })}>Report feedback</a>
            );
        } else {
            //when there's not an error, render children untouched
            return next();
        }
    }
}